// extracted by mini-css-extract-plugin
export var main = "Layout-module--main--200a4";
export var section = "Layout-module--section--5f3b5";